import { call, put } from 'redux-saga/effects';

import { updateStatus } from '@api/messages';
import { messageStatusSetModel } from '@models/messages';
import {
  messagesSetReadSuccessAction,
  messagesSetReadFailureAction,
  messagesSetArchivedSuccessAction,
  messagesSetArchivedFailureAction,
} from '@store/messages/messagesDetail/messagesDetail.actions';
import { toastError } from '@store/notifications';

export const handleSetStatusSaga = function* ({ payload }) {
  try {
    const requestData = messageStatusSetModel(payload);
    const response = yield call(updateStatus, payload.messageStatusId, requestData);
    const dispatches = [];

    if (payload.hasOwnProperty('read')) dispatches.push(messagesSetReadSuccessAction(response));
    if (payload.hasOwnProperty('archived'))
      dispatches.push(messagesSetArchivedSuccessAction(response));

    yield put(dispatches);
  } catch (error) {
    const errorMessage = error.data?.nonFieldErrors || {
      defaultMessage: 'An unexpected error occurred, please try again.',
      id: 'global.notification.api-error-default',
    };
    const dispatches = [
      toastError({
        message: errorMessage,
      }),
    ];

    if (payload.hasOwnProperty('read')) dispatches.push(messagesSetReadFailureAction());
    if (payload.hasOwnProperty('archived')) dispatches.push(messagesSetArchivedFailureAction());

    yield put(dispatches);
  }
};
